/* eslint-disable */
import {
  Stack,
  Box,
  TextField,
  ClickAwayListener,
  InputAdornment,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
  addMonths,
  addYears,
  isAfter,
  isBefore,
  isSameMonth,
  isWithinInterval,
  max,
  min,
} from 'date-fns';
import {
  formatDateForInput,
  maskDateFormatter,
  parseOptionalDate,
} from './dateFormatUtils';
import { defaultRanges } from './defaultsPresetter';
import Menu from './customCalender';
import PropTypes from 'prop-types';
import './customDateRange.scss';
import CalendarIcon from '../../Assets/images/svg/dar_calendar_blank_gray.svg';
import dayjs from 'dayjs';

const MARKERS = {
  FIRST_MONTH: Symbol('firstMonth'),
  SECOND_MONTH: Symbol('secondMonth'),
};

const DateRangeEditor = (props) => {
  const today = new Date();

  const {
    dateRange,
    onChange,
    minDate,
    maxDate,
    definedRanges = defaultRanges,
    mask = '__/__/____',
    dateInputDelimeter = '/',
    fromLabel,
    toLabel,
    fromName,
    toName,
    fromPlaceholder,
    toPlaceholder,
    dateFormat = 'mm/dd/yyyy',
    useCurrentYear = false,
    splitInitialCustomMonthView = false,
  } = props;

  const minDateValid = parseOptionalDate(minDate, addYears(today, -50));
  const maxDateValid = parseOptionalDate(maxDate, addYears(today, 50));
  const [daterange, setDaterange] = useState(definedRanges.find(range => range.label === dateRange?.label) || { label: 'Custom', startDate: null, endDate: null });
  const [hoverDay, setHoverDay] = useState(null);
  const [dateError, setDateError] = useState('');

 useEffect(() => {
  if (
    splitInitialCustomMonthView &&
    dateRange?.startDate &&
    dateRange?.endDate
  ) {
    const matchedPredefined = definedRanges.find(
      (range) =>
        range.startDate &&
        range.endDate &&
        dayjs(range.startDate).isSame(dayjs(dateRange.startDate), 'day') &&
        dayjs(range.endDate).isSame(dayjs(dateRange.endDate), 'day')
    );

    const selectedRange = matchedPredefined
      ? matchedPredefined
      : {
          label: 'Custom',
          startDate: new Date(dateRange.startDate),
          endDate: new Date(dateRange.endDate),
        };

    setDaterange(selectedRange);
    setDateFrom(formatDateForInput(selectedRange.startDate, dateFormat));
    setDateTo(formatDateForInput(selectedRange.endDate, dateFormat));
  }
}, [dateRange, definedRanges, splitInitialCustomMonthView]);



  const [firstMonth, setFirstMonth] = useState(() => {
    if (daterange.startDate) {
      return new Date(daterange.startDate);
    }
    return daterange.label === 'Last 2 Months' ? addMonths(today, -2) : addMonths(today, -1);
  }); 
  
  const [secondMonth, setSecondMonth] = useState(() => {
    if (daterange.endDate) {
      return new Date(daterange.endDate);
    }
    return daterange.label === 'Last 2 Months' ? today : addMonths(today, -1);
  });

  const [openDateRangePicker, setOpenDateRangePicker] = useState(false);
  const [dateFrom, setDateFrom] = useState(
    formatDateForInput(dateRange.startDate, dateFormat),
  );
  const [dateTo, setDateTo] = useState(formatDateForInput(dateRange.endDate, dateFormat));
 
  const isCustomRange = daterange.label === 'Custom';

  const { startDate, endDate } = daterange;

  const closeDateRangePicker = () => {
    setOpenDateRangePicker(false);
  };

useEffect(() => {
  if (
    (splitInitialCustomMonthView || openDateRangePicker) &&
    daterange.label === 'Custom' &&
    !daterange.startDate &&
    !daterange.endDate
  ) {
    setFirstMonth(addMonths(today, -1));
    setSecondMonth(today);
  }
}, [daterange, splitInitialCustomMonthView, openDateRangePicker]);

  const onModelUpdate = (newValue, dispatch = true) => {
    if (!newValue.startDate && !newValue.endDate) {
      newValue.startDate = new Date();
      newValue.endDate = new Date();
    }

    setDaterange(newValue);
    const fromdate = formatDateForInput(newValue.startDate, dateFormat);
    const todate = formatDateForInput(newValue.endDate, dateFormat);
    setDateFrom(fromdate);
    setDateTo(todate);

    dispatch && onChange(newValue);
  };

  const parseFromDate = (event) => {
    const newValue = event.target.value;
    const pdate = isDateValue(newValue);
    const today = new Date();
  
    if (pdate && pdate > endDate) {
      setDateError('Enter valid date');
      return;
    }
    
   
    if (pdate && isAfter(pdate, today)) {
      setDateError('Enter valid date');
      return;
    }
  
    setDateError(''); 
  
    const newmodel = { startDate: undefined, endDate };
    if (pdate && (!endDate || pdate < endDate)) {
      newmodel.startDate = pdate;
      setFirstMonthValidated(pdate);
      endDate && setSecondMonthValidated(isSameMonth(pdate, endDate) ? addMonths(pdate, 1) : endDate);
    }
    setDateFrom(maskDateFormatter(newValue, mask));
    setDaterange(newmodel);
    onChange(newmodel);
  };

  const parseToDate = (event) => {
    const newValue = event.target.value;
    const pdate = isDateValue(newValue);
    const today = new Date();

    if (pdate && pdate < startDate) {
      setDateError('Enter valid date');
      return;
    }
  
    if (pdate && isAfter(pdate, today)) {
      setDateError('Enter valid date');
      return;
    }
  
    setDateError(''); 
  
    const newmodel = { startDate, endDate: undefined };
  
    if (pdate && startDate && pdate >= startDate) {
      newmodel.endDate = pdate;
      setSecondMonthValidated(pdate);
      startDate && setFirstMonthValidated(isSameMonth(pdate, startDate) ? addMonths(pdate, -1) : startDate);
    }
    setDateTo(maskDateFormatter(newValue, mask));
    setDaterange(newmodel);
    onChange(newmodel);
  };
  const isDateValue = (newValue) => {
    const dvals = newValue.split(dateInputDelimeter);
    if (newValue.length === mask.length && dvals.length > 2) {
      const dt = new Date(
        parseInt(dvals[2], 10),
        parseInt(dvals[0], 10) - 1,
        parseInt(dvals[1], 10),
      );
      if (dt && dt > minDateValid && dt < maxDateValid) {
        return dt;
      }
    }
    return null;
  };

  const validateFirstMonth = (date) => {
    if (isBefore(date, secondMonth)) {
      setFirstMonth(date);
    }
  };

  const validateSecondMonth = (date) => {
    if (isAfter(date, firstMonth)) {
      setSecondMonth(date);
    }
  };

  const validateDateRange = (range) => {
    let { startDate: newStart, endDate: newEnd } = range;

    if (newStart && newEnd) {
      range.startDate = newStart = max([newStart, minDateValid]);
      range.endDate = newEnd = min([newEnd, maxDateValid]);

      onModelUpdate(range);

      setFirstMonth(newStart);
      setSecondMonth(
        isSameMonth(newStart, newEnd) ? addMonths(newStart, 1) : newEnd,
      );
    } else {
      onModelUpdate({});
      setFirstMonth(today);
      setSecondMonth(addMonths(firstMonth, 1));
    }
  };

  const onDayClick = (day) => {
    if (isCustomRange) {
      if (
        daterange.startDate &&
        !daterange.endDate &&
        !isBefore(day, daterange.startDate)
      ) {
        const newRange = { ...daterange, endDate: day };
        onModelUpdate(newRange);
      } else {
        onModelUpdate({ ...daterange, startDate: day, endDate: null }, false);
        setHoverDay(day);
      }
    }
  };

  const onMonthNavigate = (marker, action) => {
    if (marker === MARKERS.FIRST_MONTH) {
      const firstNew = addMonths(firstMonth, action);
      if (isBefore(firstNew, secondMonth)) setFirstMonth(firstNew);
    } else {
      const secondNew = addMonths(secondMonth, action);
      if (isBefore(firstMonth, secondNew)) setSecondMonth(secondNew);
    }
  };

  const onDayHover = (date) => {
    if (isCustomRange && daterange.startDate && !daterange.endDate) {
      setHoverDay(date);
    }
  };

  const inHoverRange = (day) =>
    isCustomRange &&
    daterange.startDate &&
    !daterange.endDate &&
    hoverDay &&
    isAfter(hoverDay, daterange.startDate) &&
    isWithinInterval(day, {
      start: daterange.startDate,
      end: hoverDay,
    });

  const helpers = {
    inHoverRange,
  };

  const handlers = {
    onDayClick,
    onDayHover,
    onMonthNavigate,
  };

  const onApply = () => {
    onChange(daterange);
    closeDateRangePicker();
  };

  const onCancel = () => {
   
    closeDateRangePicker();
  };

  const onCustomSelect = () => {
  const customRange = { label: 'Custom', startDate: null, endDate: null };
  setDaterange(customRange);
  setDateFrom('');
  setDateTo('');
  setHoverDay(null);
  setOpenDateRangePicker(true);
  if (!splitInitialCustomMonthView) {
    onChange(customRange);
  }
};


  return (
   
      <ClickAwayListener onClickAway={closeDateRangePicker}>
        <Box>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            className="custom-date-range-stack"
          >
            <TextField
              className="form-field-style date-input-field"
              label={fromLabel}
              name={fromName}
              placeholder={fromPlaceholder}
              variant="standard"
              autoComplete="off"
              onClick={() => setOpenDateRangePicker(true)}
              onChange={parseFromDate}
              value={dateFrom}
              InputProps={{
                sx: { cursor: 'pointer' },
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={CalendarIcon} alt="Calendar Icon" />
                  </InputAdornment>
                ),
              }}
            />
            <Box className="custom-dash-separator"> - </Box>
            <TextField
              className="form-field-style date-input-field"
              label={toLabel}
              name={toName}
              placeholder={toPlaceholder}
              variant="standard"
              autoComplete="off"
              onClick={() => setOpenDateRangePicker(true)}
              onChange={parseToDate}
              value={dateTo}
              InputProps={{
                sx: { cursor: 'pointer' },
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={CalendarIcon} alt="Calendar Icon" />
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
          {dateError && <div className="error-message">{dateError}</div>}
          <Box className="date-range-picker">
            {openDateRangePicker && (
              <Menu
                dateRange={daterange}
                minDate={minDateValid}
                maxDate={maxDateValid}
                ranges={definedRanges}
                firstMonth={firstMonth}
                secondMonth={secondMonth}
                setFirstMonth={validateFirstMonth}
                setSecondMonth={validateSecondMonth}
                setDateRange={validateDateRange}
                helpers={helpers}
                handlers={handlers}
                onApply={onApply}
                onCancel={onCancel}
                onCustomSelect={onCustomSelect}
                useCurrentYear={useCurrentYear}
              />
            )}
          </Box>
        </Box>
      </ClickAwayListener>
    
  );
};

DateRangeEditor.propTypes = {
  dateRange: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    label: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  definedRanges: PropTypes.array,
  mask: PropTypes.string,
  dateInputDelimeter: PropTypes.string,
  fromLabel: PropTypes.string,
  toLabel: PropTypes.string,
  fromName: PropTypes.string,
  toName: PropTypes.string,
  fromPlaceholder: PropTypes.string,
  toPlaceholder: PropTypes.string,
  dateFormat: PropTypes.string,
  useCurrentYear: PropTypes.bool,
  splitInitialCustomMonthView: PropTypes.bool,
};

export default DateRangeEditor;


